module.exports = __webpack_public_path__ + "img/p92.a22e70ac.png";